<div class="register-filter" ng-click="$ctrl.toggleOptions()">
    <label>{{$ctrl.filter.title|localize}}<i class="fa fa-angle-right register-arrow"></i></label>
    <div class="register-search" ng-if="$ctrl.showOptions" ng-click="$ctrl.click($event)">
        <c-dropdown-table-select items="$ctrl.lookupItems" callback="$ctrl.callback" />
        <ul class="selected-list">
            <li ng-repeat="item in $ctrl.filter.selectedItems">
                <div><span>{{item.Name}}</span></br><span class="register-path">{{item.Path}}</span></div><i class="fa fa-times hover-effects" ng-click="$ctrl.remove(item)"></i>
            </li>
        </ul>
    </div>
</div>